import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AdminStatusCssClasses } from "../AdminsUIHelpers";
import * as actions from "../../../_redux/admins/adminsActions";
import { useAdminsUIContext } from "../AdminsUIContext";

const selectedAdmins = (entities, ids) => {
  const _admins = [];
  ids.forEach((id) => {
    const admin = entities.find((el) => el.id === id);
    if (admin) {
      _admins.push(admin);
    }
  });
  return _admins;
};

export function AdminsUpdateStatusDialog({ show, onHide }) {
  // Admins UI Context
  const adminsUIContext = useAdminsUIContext();
  const adminsUIProps = useMemo(() => {
    return {
      ids: adminsUIContext.ids,
      setIds: adminsUIContext.setIds,
      queryParams: adminsUIContext.queryParams,
    };
  }, [adminsUIContext]);

  // Admins Redux state
  const { admins, isLoading } = useSelector(
    (state) => ({
      admins: selectedAdmins(state.admins.entities, adminsUIProps.ids),
      isLoading: state.admins.actionsLoading,
    }),
    shallowEqual
  );

  // if there weren't selected admins we should close modal
  useEffect(() => {
    if (!adminsUIProps.ids || adminsUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminsUIProps.ids]);

  const [status, setStatus] = useState("active");

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for updating admin by ids
    dispatch(actions.updateAdminsStatus(adminsUIProps.ids, status)).then(
      () => {
        // refresh list after update
        dispatch(actions.fetchAdmins(adminsUIProps.queryParams)).then(
          () => {
            // clear selections list
            adminsUIProps.setIds([]);
            // closing modal
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      aria-labelledby="admin-status-modal-title"
    >
      <Modal.Header closeButton className="py-4 px-6">
        <Modal.Title id="admin-status-modal-title" className="font-weight-bolder text-dark">
          Update Status for Selected Admins
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6">
        <div className="alert alert-custom alert-light-primary fade show mb-4 py-3 px-4 d-flex align-items-center" role="alert">
          <div className="alert-icon mr-3">
            <i className="fa fa-info-circle text-primary font-size-h5"></i>
          </div>
          <div className="alert-text font-size-sm text-dark font-weight-bold">
            Updating status for <span className="text-primary font-size-lg font-weight-bolder">{adminsUIProps.ids.length}</span> selected admins.
          </div>
        </div>

        <div className="form-group mb-2">
          <label className="font-weight-bold text-dark font-size-sm mb-2">
            Change Status To
          </label>
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light font-weight-bold"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={updateStatus}
          className="btn btn-primary font-weight-bold"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-notch fa-spin mr-1"></i> Updating...
            </>
          ) : (
            "Update Status"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
